unit GA.Rules;

interface

//KSS uses WebLib.ExtCtrls, XData.Web.Client, MainDataModule, JS;

const
  NO_VALID_DECLARATION_ERROR = 'No valid Gift Aid declaration covers this donation.';

type
  TGARulesUtils = class
    class function SetDonorClaimStatus(ADonorType: string; AAddressLine1: string; APostCode: string): boolean;
    class function MinDateCheck(ADate: TDate): TDate;
    /// Donor gate for Gift Aid. Pass ATransactionDate = 0 to ignore donation date (e.g. profile-only checks).
    class function DonorMeetsGiftAidRequirements(const ADonorKind, ADonorClaimStatus, AAdd1, APostCode: string;
      const ADateOfDeath, ATransactionDate: TDate; out AErrorText: string): Boolean;
    /// Final claim statuses that must never be re-evaluated or overwritten.
    class function DonationClaimStatusIsImmutable(const AClaimStatus: string): Boolean;
    /// Claim statuses that must not be edited or recomputed by general rules (immutable + on-claim pipeline).
    class function DonationClaimStatusIsLocked(const AClaimStatus: string): Boolean;
  end;


implementation

uses
  System.SysUtils;

const
  S_DONOR_NOT_ELIGIBLE = 'Donor is not eligible for Gift Aid.';
  S_DONATION_AFTER_DEATH = 'Donation date is after the donor''s date of death.';
  IMMUTABLE_DONATION_CLAIM_STATUSES: array[0..4] of string = (
    'Cancelled', 'Deleted', 'Confirmed', 'Claimed', 'Received');
  LOCKED_DONATION_CLAIM_STATUSES: array[0..8] of string = (
    'Cancelled', 'Deleted', 'Scheduled', 'Submitting', 'Confirmed', 'Claimed', 'Received', 'AdjustmentPending', 'ClaimReversed');

function IsOkIndividualDonorWithAddress(const ADonorKind, ADonorClaimStatus, AAdd1, APostCode: string): Boolean;
begin
  Result := (Trim(ADonorKind) = 'Individual') and (Trim(AAdd1) <> '') and (Trim(APostCode) <> '') and
    SameText(Trim(ADonorClaimStatus), 'OK');
end;

class function TGARulesUtils.DonorMeetsGiftAidRequirements(const ADonorKind, ADonorClaimStatus, AAdd1,
  APostCode: string; const ADateOfDeath, ATransactionDate: TDate; out AErrorText: string): Boolean;
begin
  AErrorText := '';

  if SameText(Trim(ADonorClaimStatus), 'Deceased') then
  begin
    if (ADateOfDeath > 0) and (ATransactionDate > 0) and (ATransactionDate > ADateOfDeath) then
    begin
      AErrorText := S_DONATION_AFTER_DEATH;
      Exit(False);
    end;

    if (Trim(ADonorKind) <> 'Individual') or (Trim(AAdd1) = '') or (Trim(APostCode) = '') then
    begin
      AErrorText := S_DONOR_NOT_ELIGIBLE;
      Exit(False);
    end;

    Exit(True);
  end;

  if not IsOkIndividualDonorWithAddress(ADonorKind, ADonorClaimStatus, AAdd1, APostCode) then
  begin
    if SameText(Trim(ADonorClaimStatus), 'OK') then
      AErrorText := S_DONOR_NOT_ELIGIBLE
    else
      AErrorText := Format('%s (%s)', [S_DONOR_NOT_ELIGIBLE, Trim(ADonorClaimStatus)]);
    Exit(False);
  end;

  Result := True;
end;

class function TGARulesUtils.SetDonorClaimStatus(ADonorType: string; AAddressLine1: string; APostCode: string): boolean;
var
  lOk: boolean;
begin
  lOk := true;
  if ADonorType <> 'Individual' then
    lOk := false;
  if (ADonorType = 'Individual') and ((AAddressLine1 = '') or (APostCode = '')) then
    lOk := false;

  result := lOk;
end;

// Check to see if the date is above the min date - this was because
// two digit years were being add
class function TGARulesUtils.MinDateCheck(ADate: TDate): TDate;
const
  MINDATE = 29221; //'01-01-1980
begin
  if ADate < MINDATE then
    result := 0
  else
    result := ADate;
end;

class function TGARulesUtils.DonationClaimStatusIsImmutable(const AClaimStatus: string): Boolean;
var
  lStatus: string;
  lImmutableStatus: string;
begin
  lStatus := Trim(AClaimStatus);
  if lStatus = '' then
    Exit(False);

  for lImmutableStatus in IMMUTABLE_DONATION_CLAIM_STATUSES do
  begin
    if SameText(lStatus, lImmutableStatus) then
      Exit(True);
  end;

  Result := False;
end;

class function TGARulesUtils.DonationClaimStatusIsLocked(const AClaimStatus: string): Boolean;
var
  lStatus: string;
  lLockedStatus: string;
begin
  lStatus := Trim(AClaimStatus);
  if lStatus = '' then
    Exit(False);

  for lLockedStatus in LOCKED_DONATION_CLAIM_STATUSES do
  begin
    if SameText(lStatus, lLockedStatus) then
      Exit(True);
  end;

  Result := False;
end;

end.
